/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeatures = {
  init($section) {
    const $slider = $section.find('[data-features-slider]');
    if (!$slider.length || typeof jQuery.fn.flickity !== 'function') return;
    if ($slider.data('flickity')) return;

    // Défilement automatique du bandeau de réassurance (mobile uniquement :
    // l'activation est pilotée par le CSS via watchCSS, sous 480px).
    // Pour changer la vitesse, modifier AUTOPLAY_MS ci-dessous (millisecondes).
    const AUTOPLAY_MS = 3500;

    // Respecte le réglage système "réduire les animations".
    const reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $slider.flickity({
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      watchCSS: true,
      draggable: true,
      autoPlay: reduceMotion ? false : AUTOPLAY_MS,
      pauseAutoPlayOnHover: true,
    });

    $slider.on('settle.flickity', () => {
      if ($slider.hasClass('flickity-enabled')) {
        $slider.flickity('resize');
      }
    });
  },

  unload($section) {
    const $slider = $section.find('[data-features-slider]');
    if (!$slider.length) return;
    if ($slider.data('flickity')) {
      $slider.off('settle.flickity');
      $slider.flickity('destroy');
    }
  },
};

/******/ })();